module.exports = __webpack_public_path__ + "static/safeut-logo-e03caf9a88ee15af71a705cfc666e0aa.png";